// src/components/admin/pagos/ComprobanteViewer.js
import React, { useEffect, useState } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle, Button } from '../../ui'
import { Download, ExternalLink } from 'lucide-react'
import { getComprobanteSignedUrl } from '../../../lib/supabase'

const ComprobanteViewer = ({ open, onOpenChange, path, filename = 'comprobante' }) => {
  const [url, setUrl] = useState(null)
  const [downloadUrl, setDownloadUrl] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!open || !path) return
    let cancelled = false
    setLoading(true)
    Promise.all([
      getComprobanteSignedUrl(path),
      getComprobanteSignedUrl(path, { downloadFilename: filename }),
    ]).then(([viewU, dlU]) => {
      if (cancelled) return
      setUrl(viewU)
      setDownloadUrl(dlU)
      setLoading(false)
    })
    return () => { cancelled = true }
  }, [open, path, filename])

  const isPdf = path?.toLowerCase().endsWith('.pdf')

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>Comprobante</DialogTitle>
        </DialogHeader>
        {loading && <p className="text-sm text-muted-foreground">Cargando...</p>}
        {!loading && !url && <p className="text-sm text-red-600">No se pudo cargar el comprobante.</p>}
        {!loading && url && (
          <>
            {isPdf ? (
              <iframe src={url} title="comprobante" className="w-full h-[600px] border rounded" />
            ) : (
              <img src={url} alt="comprobante" className="max-h-[600px] mx-auto rounded" />
            )}
            <div className="flex gap-2 justify-end pt-2">
              {downloadUrl && (
                <Button asChild variant="outline" size="sm">
                  <a href={downloadUrl}>
                    <Download className="h-4 w-4 mr-1" /> Descargar
                  </a>
                </Button>
              )}
              <Button asChild size="sm">
                <a href={url} target="_blank" rel="noopener noreferrer">
                  <ExternalLink className="h-4 w-4 mr-1" /> Abrir en nueva pestania
                </a>
              </Button>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  )
}

export default ComprobanteViewer
